<template lang="pug">
    div(v-if="getShowPreLoadScreen" @mouseup="enterSite()" style="position:absolute; width:100%; height:100%; left:0; top:0; overflow:hidden;")
        div(style="position:absolute; left:0; top:0; width:100%; height:100%; background-color:#144B4E; opacity:0.8; z-index:10000000000;")

        div(style="position:absolute; left:-200px; top:-200px; width:900px; height:900px; background-color:#EEBC9B; border-radius:50%; z-index:100000000000;")

        div(style="position:absolute; left:50px; top:50px; color:#144B4E; z-index:1000000000000; border:0px solid;")
            div
                div(style="border:0px solid;")
                    img(src="/images/logos/edger-finance.svg")

            div(v-html="$t('splash_screen_main_text')" style="margin-top:50px; border:0px solid;")

            div(style="font-size:16px; font-weight:600; height:40px; margin-top:30px; border:0px solid;")
                div(@mousedown="logIn()" style="float:left; height:40px; padding-left:25px; padding-right:25px; color:#EEBC9B; cursor:pointer; background-color:#144B4E; padding-top:6px; border-radius:20px; border:3px solid #144B4E;") {{ $t('Log_in') }}
                div(style="float:left; height:40px; margin-left:15px; padding-left:25px; padding-right:25px; cursor:pointer; padding-top:6px; border-radius:20px; border:3px solid;") {{ $t('show_me_more') }}

        div(style="position:absolute; right:-200px; bottom:-600px; width:800px; height:800px; background-color:#EEBC9B; color:#144B4E; border-radius:50%; z-index:1000000000000; border:0px solid;")
            div(style="position:relative; width:100%; height:100%; border:0px solid;")
                div(style="position:absolute; top:80px; left:250px; font-size:1.05em; border:0px solid;")
                    div
                        div(style="font-size:12px; font-weight:600; border:0px solid;") {{ $t('in_partnership_with') }}
                        div(style="position:relative; margin-top:10px; border:0px solid;")
                            img(src="/images/logos/spotlight-logo--black.svg" style="width:220px;")
                            div(style="position:absolute; font-size:11px; font-weight:500; letter-spacing:1.5px; bottom:7px; color:black; border:0px solid;") STOCK MARKET
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'EdgerSplashScreen',
    data() {
        return {
            showPreLoadScreen: true
        };
    },
    computed: {
        ...mapGetters([
            'getShowPreLoadScreen'
        ])
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows',
            'setShowPreLoadScreen'
        ]),
        enterSite() {
            this.setShowPreLoadScreen(false);
        },
        logIn() {
            this.setShowPreLoadScreen(false);

            this.setRegisterType('login');
            this.setRegisterWindows(true);
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

div {
    font-family: 'Poppins', sans-serif;
}
</style>
